/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1InfluencerId200,
  GetApiV1InfluencerId401,
  GetApiV1InfluencerId404,
  GetApiV1InfluencerId500,
  GetApiV1InfluencerIdPathParams,
  GetApiV1InfluencerIdQueryResponse,
} from "../../types/influencerRegistroController/GetApiV1InfluencerId.ts";
import { influencerViewModelSchema } from "../influencerViewModelSchema.ts";

export const getApiV1InfluencerIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1InfluencerIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1InfluencerId200Schema = z.lazy(
  () => influencerViewModelSchema,
) as unknown as ToZod<GetApiV1InfluencerId200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1InfluencerId401Schema =
  z.any() as unknown as ToZod<GetApiV1InfluencerId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1InfluencerId404Schema =
  z.any() as unknown as ToZod<GetApiV1InfluencerId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1InfluencerId500Schema =
  z.any() as unknown as ToZod<GetApiV1InfluencerId500>;

export const getApiV1InfluencerIdQueryResponseSchema = z.lazy(
  () => getApiV1InfluencerId200Schema,
) as unknown as ToZod<GetApiV1InfluencerIdQueryResponse>;
